module.exports = __webpack_public_path__ + "static/media/platines.78dd06f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/platines.svg
// module id = 255
// module chunks = 0